// extracted by mini-css-extract-plugin
export default {"periodTitle":"comparativeRevenueReport_periodTitle__+rxLj","pageSpacer":"comparativeRevenueReport_pageSpacer__HqBJE","errorText":"comparativeRevenueReport_errorText__U1MA+"};